import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { HttpClient } from '@angular/common/http';
import * as M from "materialize-css/dist/js/materialize";
import * as $ from 'jquery';
import { VirtualTimeScheduler } from 'rxjs';
import * as moment from 'moment';
//import { TestingArchitectHost } from 'node_modules copy/@angular-devkit/architect/testing';

@Component({
	selector: 'app-home',
	templateUrl: './home.component.html',
	styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {
	loading : boolean = false; 
	currentView = 'main';
	//old
	sortOption = 1; //dozvoljene vrijednosti su bodovi i vrijeme
	pregledi : any = [];
	datumPretraga : any = null;
	odDatumPretraga : any = null;
	odabraniPregled : any = null;
	nazivProizvodjaca : any = null; 
	regBroj : any = null;
	idAuta : any = null;

	constructor(public globalSrvc: GlobalService, public http : HttpClient) { }

	ngOnInit() {
		this.datumPretraga = moment().format('DD.MM.YYYY');
		this.odDatumPretraga = moment().format('DD.MM.YYYY');
		//this.ucitajStudProgram();	
		this.ucitajPreglede();
	}

	ucitajPreglede(){
		this.loading = true; 
		setTimeout(() => {
			this.http.get(this.globalSrvc.rootUrl + '/pregledi/zadatum', {params: { odDatum : this.odDatumPretraga, doDatum:this.datumPretraga}})
			.subscribe(data => {
				this.pregledi = data;
				//console.log(data);
				this.loading = false;
			},
			error => {
				this.loading = false;
			});	
		}, 1000);
	}

	pretraziPoDatumu(){
		this.ucitajPreglede();
	}

	logout(){
		this.globalSrvc.logout();
		this.globalSrvc.redirectToLogin();
	}

	result : any = null;

	onCancel(data){
		this.currentView = 'main';
	}

	pregledVlasnici(vlasnik){
		this.currentView = 'pregledauto';
	}

	dodajPravnoLice(){
		this.currentView = 'vlasnici';
	}

	liste(){
		this.currentView = 'sifrarnici';
	}

	pretragaVozila(){
		this.currentView = 'vozila';
	}

	onInsertPregled(data){
		this.currentView = 'main';
		this.ucitajPreglede();
	}

	msg : any = null;

	uvjerenje(pregled){
        //console.log(this.ucenik);
        this.loading = true;
        let url = 'getReport/uvjerenje';
        
        this.http.get(url, {params : {'idPregleda' : pregled.id}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'pdf');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom generisanja rang liste');
        });    
    }

	openhelp(){
		
        let url = 'upustvo';
        this.http.get(url, {params : {}, responseType: 'blob'})
        .subscribe(
         data => {            
            this.loading = false;
            this.globalSrvc.openBlob(data, 'pdf');
         },
         error => {            
            this.loading = false;
            window.alert('Došlo je do greške prilikom fajla');
        });   
	}

	evidencija(){
		this.loading = true;
		let url = 'pregled/evidencija';

		this.http.get(url, { params: { odDatum : this.odDatumPretraga, doDatum:this.datumPretraga }, responseType: 'blob' })
			.subscribe(
				data => {
					this.loading = false;
					this.globalSrvc.openBlob(data, 'word');
				},
				error => {
					this.loading = false;
					window.alert('Došlo je do greške prilikom generisanja izvjestaja');
				});
	}

	genizvjestaj(){
		this.loading = true;
		let url = 'pregled/izvjestaj';

		this.http.get(url, { params: { odDatum : this.odDatumPretraga, doDatum:this.datumPretraga }, responseType: 'blob' })
			.subscribe(
				data => {
					this.loading = false;
					this.globalSrvc.openBlob(data, 'word');
				},
				error => {
					this.loading = false;
					window.alert('Došlo je do greške prilikom generisanja izvjestaja');
				});
	}

	pregledPregleda(pregled){
		this.odabraniPregled = pregled.id;
		this.nazivProizvodjaca =  pregled.nazivProizvodjaca; 
		this.regBroj = pregled.registracija;
		this.idAuta = pregled.idAuta; 

		this.currentView = 'pregled';
	}

	zapisnik(pregled, vrsta) {
		this.loading = true;
		let url = 'pregled/zapisnik';

		if(vrsta == 'AD')url = 'pregled/zapisnikAD';

		this.http.get(url, { params: { 'idPregleda': pregled.id }, responseType: 'blob' })
			.subscribe(
				data => {
					this.loading = false;
					this.globalSrvc.openBlob(data, 'word');
				},
				error => {
					this.loading = false;
					window.alert('Došlo je do greške prilikom generisanja rang liste');
				});
	}

	izvjetajPlombiranje(pregled) {
		this.loading = true;
		let url = 'pregled/zapisnik/plomba';

		this.http.get(url, { params: { 'idPregleda': pregled.id }, responseType: 'blob' })
			.subscribe(
				data => {
					this.loading = false;
					this.globalSrvc.openBlob(data, 'word');
				},
				error => {
					this.loading = false;
					window.alert('Došlo je do greške prilikom generisanja rang liste');
				});
	}
}
